import {
  BaseReactiveValue1ggyqczzm31cy as BaseReactiveValue,
  BaseListenable1u3g4s45l82o6 as BaseListenable,
} from '../core/abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../core/signals.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
  Reactive1jy75v4li6ldv as Reactive,
} from '../core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotActive2613wuivyis0b as InternalReactiveNotActive,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  ReactiveStatel8ixobo86msn as ReactiveState,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
} from '../core/ReactiveState.mjs';
import {
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { Job13y4jkazwjho0 as Job } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function lensByElementAssumingSetNeverManipulates(_this__u8e3s4) {
  return lensByElementAssumingSetNeverManipulates_0(_this__u8e3s4, lensByElementAssumingSetNeverManipulates$lambda);
}
function lensByElementAssumingSetNeverManipulates_0(_this__u8e3s4, map) {
  return LensByElementAssumingSetNeverManipulates().new_com_lightningkite_reactive_lensing_LensByElementAssumingSetNeverManipulates_8qte04_k$(_this__u8e3s4, map);
}
var InstanceClass;
function Instance() {
  if (InstanceClass === VOID) {
    class $ extends BaseReactiveValue() {
      constructor($outer, calculationContext, index, value) {
        return new.target.new_com_lightningkite_reactive_lensing_LensByElementAssumingSetNeverManipulates_Instance_ed5tec_k$($outer, calculationContext, index, value);
      }
      static new_com_lightningkite_reactive_lensing_LensByElementAssumingSetNeverManipulates_Instance_ed5tec_k$($outer, calculationContext, index, value, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        var $this = this.new_com_lightningkite_reactive_core_BaseReactiveValue_bwum4c_k$(value, $box);
        $this.mapped_1 = $this.$this_1.map_1(calculationContext, $this);
        $this.index_1 = new (Constant())(_Constant___init__impl__v45mub(index));
        return $this;
      }
      get_index_it478p_k$() {
        return this.index_1;
      }
      *set_fmwrf7_k$(value, $completion) {
        this.set_value_v1vabv_k$(value);
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.$this_1.sources_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = item.get_value_j01efc_k$();
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        yield* this.$this_1.source_1.set_revjhg_k$(destination, $completion);
        return Unit_instance;
      }
      set_revjhg_k$(value, $completion) {
        return this.set_fmwrf7_k$(value, $completion);
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, 'Instance', VOID, VOID, [MutableReactive(), ReactiveValue()], [1]);
    InstanceClass = $;
  }
  return InstanceClass;
}
var LensByElementAssumingSetNeverManipulatesClass;
function LensByElementAssumingSetNeverManipulates() {
  if (LensByElementAssumingSetNeverManipulatesClass === VOID) {
    class $ extends BaseListenable() {
      constructor(source, map) {
        return new.target.new_com_lightningkite_reactive_lensing_LensByElementAssumingSetNeverManipulates_8qte04_k$(source, map);
      }
      static new_com_lightningkite_reactive_lensing_LensByElementAssumingSetNeverManipulates_8qte04_k$(source, map) {
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$();
        $this.source_1 = source;
        $this.map_1 = map;
        $this.sources_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        $this._state_1 = Companion_getInstance().notReady_1;
        $this.myListen_1 = null;
        $this.suppress_1 = false;
        $this.old_1 = null;
        return $this;
      }
      activate_yijg9v_k$() {
        super.activate_yijg9v_k$();
        var tmp = this;
        tmp.myListen_1 = this.source_1.addListener_6y9mct_k$(() => {
          this.refresh_6a3uvf_k$();
          this.invokeAllListeners_uusj2y_k$();
          return Unit_instance;
        });
        this.refresh_6a3uvf_k$();
      }
      deactivate_pmdz1g_k$() {
        super.deactivate_pmdz1g_k$();
        var tmp0_safe_receiver = this.myListen_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.myListen_1 = null;
      }
      get_state_1rbput_k$() {
        if (this.myListen_1 == null) {
          this.refresh_6a3uvf_k$();
        }
        return this._state_1;
      }
      get_state_wc71uu_k$() {
        return this.get_state_1rbput_k$();
      }
      refresh_6a3uvf_k$() {
        if (this.suppress_1)
          return Unit_instance;
        var tmp0_safe_receiver = this.old_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          cancel(tmp0_safe_receiver);
        }
        var context = CoroutineScope(Job());
        this.old_1 = context;
        var tmp = this;
        var tmp0 = this.source_1.get_state_wc71uu_k$();
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.map' call
          var tmp_0;
          var tmp_1;
          var tmp_2 = _ReactiveState___get_raw__impl__92ipya(tmp0);
          if (tmp_2 instanceof InternalReactiveNotReady()) {
            tmp_1 = true;
          } else {
            var tmp_3 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            tmp_1 = tmp_3 instanceof InternalReactiveNotActive();
          }
          if (tmp_1) {
            tmp_0 = true;
          } else {
            var tmp_4 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            tmp_0 = tmp_4 instanceof InternalReactiveThrownException();
          }
          if (tmp_0) {
            tmp$ret$0 = new (ReactiveState())(tmp0) instanceof ReactiveState() ? tmp0 : THROW_CCE();
            break $l$block_1;
          }
          var tmp_5 = _ReactiveState___get_raw__impl__92ipya(tmp0);
          if (tmp_5 instanceof InternalReactiveWrapper())
            try {
              var it = _ReactiveState___get_raw__impl__92ipya(tmp0).other_1;
              this.sources_1.clear_j9egeb_k$();
              // Inline function 'kotlin.collections.mapIndexed' call
              // Inline function 'kotlin.collections.mapIndexedTo' call
              var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(it, 10));
              var index = 0;
              var _iterator__ex2g4s = it.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var item = _iterator__ex2g4s.next_20eer_k$();
                var _unary__edvuaz = index;
                index = _unary__edvuaz + 1 | 0;
                var index_0 = checkIndexOverflow(_unary__edvuaz);
                var tmp$ret$4 = Instance().new_com_lightningkite_reactive_lensing_LensByElementAssumingSetNeverManipulates_Instance_ed5tec_k$(this, context, index_0, item);
                destination.add_utx5q5_k$(tmp$ret$4);
              }
              this.sources_1.addAll_4lah1e_k$(destination);
              // Inline function 'kotlin.collections.map' call
              var this_0 = this.sources_1;
              // Inline function 'kotlin.collections.mapTo' call
              var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
              var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
                var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
                var tmp$ret$7 = item_0.mapped_1;
                destination_0.add_utx5q5_k$(tmp$ret$7);
              }
              tmp$ret$0 = _ReactiveState___init__impl__fvdp9b(destination_0);
              break $l$block_1;
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                tmp$ret$0 = Companion_getInstance().exception_iibuh2_k$(e);
                break $l$block_1;
              } else {
                throw $p;
              }
            }
          var tmp_6;
          try {
            var it_0 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            this.sources_1.clear_j9egeb_k$();
            // Inline function 'kotlin.collections.mapIndexed' call
            // Inline function 'kotlin.collections.mapIndexedTo' call
            var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(it_0, 10));
            var index_1 = 0;
            var _iterator__ex2g4s_1 = it_0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
              var item_1 = _iterator__ex2g4s_1.next_20eer_k$();
              var _unary__edvuaz_0 = index_1;
              index_1 = _unary__edvuaz_0 + 1 | 0;
              var index_2 = checkIndexOverflow(_unary__edvuaz_0);
              var tmp$ret$11 = Instance().new_com_lightningkite_reactive_lensing_LensByElementAssumingSetNeverManipulates_Instance_ed5tec_k$(this, context, index_2, item_1);
              destination_1.add_utx5q5_k$(tmp$ret$11);
            }
            this.sources_1.addAll_4lah1e_k$(destination_1);
            // Inline function 'kotlin.collections.map' call
            var this_1 = this.sources_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination_2 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s_2 = this_1.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
              var item_2 = _iterator__ex2g4s_2.next_20eer_k$();
              var tmp$ret$14 = item_2.mapped_1;
              destination_2.add_utx5q5_k$(tmp$ret$14);
            }
            tmp_6 = _ReactiveState___init__impl__fvdp9b(destination_2);
          } catch ($p_0) {
            var tmp_7;
            if ($p_0 instanceof Exception()) {
              var e_0 = $p_0;
              tmp_7 = Companion_getInstance().exception_iibuh2_k$(e_0);
            } else {
              throw $p_0;
            }
            tmp_6 = tmp_7;
          }
          tmp$ret$0 = tmp_6;
        }
        tmp._state_1 = tmp$ret$0;
      }
    }
    initMetadataForClass($, 'LensByElementAssumingSetNeverManipulates', VOID, VOID, [Reactive()]);
    LensByElementAssumingSetNeverManipulatesClass = $;
  }
  return LensByElementAssumingSetNeverManipulatesClass;
}
function lensByElementAssumingSetNeverManipulates$lambda($this$lensByElementAssumingSetNeverManipulates, it) {
  return it;
}
//region block: exports
export {
  lensByElementAssumingSetNeverManipulates as lensByElementAssumingSetNeverManipulates1yt8q6qtxcnsa,
};
//endregion

//# sourceMappingURL=LensByElementAssumingSetNeverManipulates.mjs.map
